import produce from 'immer';
import './types';
import { SET_FEATURED_HEAD_TO_HEAD } from '../actions';

/**
 * @type {FeaturedHeadToHeadState}
 */
const initialState = {
    data: {}
};

/**
 * @param {FeaturedHeadToHeadState} state - The Redux state.
 * @param {FeaturedHeadToHeadActions} action - The Redux action.
 * @returns {FeaturedHeadToHeadState} The updated Redux state.
 */
export const featuredHeadToHeadReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_FEATURED_HEAD_TO_HEAD:
                draft.data = action.payload;
                break;
            default:
                draft;
        }
    });
};
